
<script>
import { mapState } from "vuex"
import VueContext from 'vue-context'
import 'vue-context/dist/css/vue-context.css'
import moment from 'moment'

export default {
  name: "MostraPlacas",
  components: {
    VueContext
  },
  data: function () {
    return {
      viewerOptions: {
        rotatable: false,
        scalable: false,
        title: false,
        keyboard: false,
      },
      colunas_itaipu: [
        {
          key: "placa",
          sortable: false,
        },
        {
          key: "velocidade",
          label: "km/h",
          sortable: false,
        },
        {
          key: "dataImagem",
          sortable: false,
          label: "Data",
          formatter(e) {
            return moment(String(e)).format("DD/MM/YYYY HH:mm:ss")
          }
        },
        {
          key: "nomLogradouro",
          sortable: false,
          label: "Logradouro",
        },
      ],
      colunas: [
        {
          key: "placa",
          sortable: false,
        },
        {
          key: "dataImagem",
          sortable: false,
          label: "Data",
          formatter(e) {
            return moment(String(e)).format("DD/MM/YYYY HH:mm:ss")
          }
        },
        {
          key: "nomLogradouro",
          sortable: false,
          label: "Logradouro",
        },
      ],
      colunasCSV:['Placa', 'Data', 'Logradouro', 'Latitude', 'Longitude', 'Coordernadas'],
      colunasCSVTabela:['placa', 'dataImagem', 'nomLogradouro', 'latitude', 'longitude'],
      slide: 0,
      sliding: null,
      selectedResultadoLinha: {},
      selectedCheckbox: [],
      rowNumberClick: 0,
      perPage: 10,
      currentPage: 1,
      index: 0,
      indexAntigo: 0,
      nomImagemP: "",
      nomImagemZ: "",
      imagemP: "",
      imagemZ: "",
      dictPages: {},
      selectedPage: [],
    }
  },
  computed: {
    ...mapState({
      ip: state => state.modulePrincipal.ip,
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo,
      pesquisaplacapg: state => state.modulePesquisa.pesquisaplacapg,
      pesquisaplacapgbk: state => state.modulePesquisa.pesquisaplacapgbk,
      pesquisaqtdplacas: state => state.modulePesquisa.pesquisaqtdplacas,
      pp: state => state.modulePesquisa.buscarpesquisaplacas,
      pagesize: state => state.modulePesquisa.pagesize
    }),
  },
  methods: {
    onSlideStart () {
        this.sliding = true
    },
    onSlideEnd () {
        this.sliding = false
    },
    rowSelected (e) {
        "" != e && (this.selectedResultadoLinha = e[0], this.imagemP = this.selectedResultadoLinha.imagemP, this.imagemZ = this.selectedResultadoLinha.imagemZ, this.nomImagemP = this.selectedResultadoLinha.nomImagemP, this.nomImagemZ = this.selectedResultadoLinha.nomImagemZ, this.slide = 0, this.rowNumberClick = this.$refs.selectableTable.selectedRows.length + (this.$refs.selectableTable.currentPage - 1) * this.perPage)
    },
    onPreviewClick (e, t, a) {
        this.selectedCheckbox.push(a.id)
    },
    onFiltered () {
        this.currentPage = 1
    },
    selectedAnterior () {
        var e = this.$refs.selectableTable.selectedRows.length;
        this.index = e - 2, 0 == e && -2 == this.index ? this.index = this.$refs.selectableTable.items.length - 1 : this.index < 0 && (this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1, this.index = 9), this.$refs.selectableTable.selectRow(this.index)
    },
    selectedProximo () {
        this.indexAntigo = this.index, this.index = this.$refs.selectableTable.selectedRows.length, this.indexAntigo == this.index ? this.index = 0 : 10 == this.index && (this.currentPage = this.currentPage + 1, this.index = this.rowNumberClick = 0), this.$refs.selectableTable.selectRow(this.index)
    },
    salvarImg (e, t) {
        var a = document.createElement("a");
        a.href = e, a.download = t, a.click()
    },
    onClick (e) {
        var t = this.usuario,
            a = this.clientinfo,
            o = this.user.cidade,
            s = "";
        "SalvarInteira" == e && (s = this.nomImagemP, this.$store.dispatch("SALVARIMAGEM", {
            usuario: t,
            clientinfo: a,
            cidade: o,
            nomeImagem: s
        }), this.salvarImg(this.imagemP, s)), "SalvarZoom" == e && (s = this.nomImagemZ, this.$store.dispatch("SALVARIMAGEM", {
            usuario: t,
            clientinfo: a,
            cidade: o,
            nomeImagem: s
        }), this.salvarImg(this.imagemZ, s)), "SalvarAmbas" == e && (s = this.nomImagemP, this.$store.dispatch("SALVARIMAGEM", {
            usuario: t,
            clientinfo: a,
            cidade: o,
            nomeImagem: s
        }), this.salvarImg(this.imagemP, s), s = this.nomImagemZ, this.$store.dispatch("SALVARIMAGEM", {
            usuario: t,
            clientinfo: a,
            cidade: o,
            nomeImagem: s
        }), this.salvarImg(this.imagemZ, s))
    },
    onClickCSV(){
      const csvRows = [];
      csvRows.push(this.colunasCSV.join(','));
      this.selectedPage.forEach(row => {
        let values = ""
        values = this.colunasCSVTabela.map(header => row[header]);
        values = values.join(',')
        const coord = "http://maps.google.com/maps?q="+row['latitude']+","+row['longitude']
        values += ',"'+ coord + '"' 
        csvRows.push(values);
      });
      const csvString = csvRows.join('\n');

      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      const nomeArquivo = this.user.cidade + '_pg'+ this.currentPage
      link.setAttribute('download', nomeArquivo + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      var t = this.usuario,
          a = this.clientinfo,
          o = this.user.cidade;
      this.$store.dispatch("MONITORAR", {
            usuario: t,
            clientinfo: a,
            cidade: o,
            procedimento: 'Salvou o CSV',
            descricao: 'Cidade: ' + this.user.cidade + ' - pg:'+ this.currentPage
        })
    }
  },  
  watch: {
    pesquisaqtdplacas () {
      this.dictPages = {}
      this.dictPages[this.pesquisaplacapg[0].pagina] = this.pesquisaplacapg
      this.currentPage = 1
      this.imagemP = ""
      this.imagemZ = ""
      this.rowNumberClick = 0
      this.index = 0
    },
    pesquisaplacapg () {
      try {
        this.dictPages[this.pesquisaplacapg[0].pagina] = this.pesquisaplacapg
        this.selectedPage = this.pesquisaplacapg
      } catch (error) {
        this.$store.state.pesquisaqtdplacas = 0
        this.dictPages = []
        this.selectedPage = []
        this.imagemP = ""
        this.imagemZ = ""
        this.rowNumberClick = 0
        this.selectedResultadoLinha = {}
      }
    },
    currentPage () {
      var e, t = this.currentPage,
          a = this.usuario,
          o = this.pp,
          s = this.user.cidade,
          r = this.pagesize,
          i = this.pesquisaqtdplacas / this.pagesize;
      this.currentPage in this.dictPages ? (this.selectedPage = this.dictPages[this.currentPage], e = t - 1, e > 0 && !(e in this.dictPages) && this.$store.dispatch("PESQUISAPLACASPGBK", {
          usuario: a,
          pesquisa: o,
          cidade: s,
          pagebk: e,
          pagesize: r
      }), e = t + 1, this.currentPage < i && !(e in this.dictPages) && this.$store.dispatch("PESQUISAPLACASPGBK", {
          usuario: a,
          pesquisa: o,
          cidade: s,
          pagebk: e,
          pagesize: r
      })) : (this.$store.dispatch("PESQUISAPLACASPG", {
          usuario: a,
          pesquisa: o,
          cidade: s,
          page: t,
          pagesize: r
      }), e = t - 1, e > 0 && !(e in this.dictPages) && this.$store.dispatch("PESQUISAPLACASPGBK", {
          usuario: a,
          pesquisa: o,
          cidade: s,
          pagebk: e,
          pagesize: r
      }), e = t + 1, this.currentPage < i && !(e in this.dictPages) && this.$store.dispatch("PESQUISAPLACASPGBK", {
          usuario: a,
          pesquisa: o,
          cidade: s,
          pagebk: e,
          pagesize: r
      }))
    },
    pesquisaplacapgbk () {
      this.dictPages[this.pesquisaplacapgbk[0].pagina] = this.pesquisaplacapgbk;
    },
  },
};
</script>

<template>
  <b-container class="container">
    <b-row>
      <b-col cols=12 md="6">
        <b-row>
          <b-col class="text-left">
            <b>Resultado: {{rowNumberClick + currentPage * perPage - 10}} / {{pesquisaqtdplacas + 1}}</b> 
          </b-col>
          <b-col class="text-right mb-2">
            <b-button size="sm" @click="onClickCSV" :disabled="selectedPage.length == 0" :variant="selectedPage.length == 0 ? '' : 'success'">CSV</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table v-if="user.cidade == 'Itaipu'" id="tabela" class="small tabelaInfo" ref="selectableTable"
              :items="selectedPage" :per-page="perPage" :fields="colunas_itaipu"
              striped bordered selectable 
              select-mode="single" @row-selected="rowSelected"
              @filtered='onFiltered' >
            </b-table>
            <b-table v-else id="tabela" class="small tabelaInfo" ref="selectableTable"
              :items="selectedPage" :per-page="perPage" :fields="colunas"
              striped bordered selectable 
              select-mode="single" @row-selected="rowSelected"
              @filtered='onFiltered' >
            </b-table>
            <b-pagination
              v-model="currentPage" :total-rows="pesquisaqtdplacas"
              :per-page="perPage" aria-controls="tabela" first-number
              last-number align="fill" size="sm">
            </b-pagination>
          </b-col>
        </b-row>
      </b-col>
      <!-- segunda coluna -->
      <b-col cols=12 md="6" @contextmenu.prevent="$refs.menu.open">
        <p class="text-left" align-v="center"><b>Imagem: {{this.selectedResultadoLinha.placa}} {{this.selectedResultadoLinha.nomLogradouro}} - {{this.selectedResultadoLinha.dataImagem}}</b></p>
        <b-row>
          <b-col>
            <button type="button" class="btn float-left btn-secondary btn-sm" @click="selectedAnterior">‹</button>
          </b-col>
          <b-col>
            <button type="button" class="btn float-right btn-secondary btn-sm" @click="selectedProximo">›</button>
          </b-col>
        </b-row>
        <viewer :options="{'title': false}">
          <b-carousel
            id="carousel-1" v-model="slide" :interval="0" fade
            controls indicators
            background="#ababab" style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd" :value="viewerOptions">
            <b-carousel-slide caption="Panoramica" v-if='"" != this.nomImagemP'
              :img-src="this.imagemP">
            </b-carousel-slide>
            <b-carousel-slide caption="Recorte" v-if='"" != this.nomImagemZ'
              :img-src="this.imagemZ">
            </b-carousel-slide>
          </b-carousel>
        </viewer>
      </b-col>
      <vue-context ref="menu">
        <li><a @click.prevent="onClick('SalvarInteira')">Salvar Imagem Inteira</a></li>
        <li><a @click.prevent="onClick('SalvarZoom')">Salvar Imagem Zoom</a></li>
        <li><a @click.prevent="onClick('SalvarAmbas')">Salvar Ambas Imagem</a></li>
      </vue-context>
    </b-row>
  </b-container>
</template>


<style>
  .carousel-item img {
    width: 100vh!important;
    max-height: 500px !important;
  }
  .viewer-open img {
    pointer-events: none;
  }
</style>